export enum FamilleLaverie {
  HOTEL = "HOTEL",
  BASE_MILITAIRE = "BASE_MILITAIRE",
  LOGEMENT_SOCIAL = "LOGEMENT_SOCIAL",
  RESIDENCE_JEUNES = "RESIDENCE_JEUNES",
  RESIDENCE_ETUDIANT = "RESIDENCE_ETUDIANT",
  RESIDENCE_DE_TOURISME = "RESIDENCE_DE_TOURISME",
  AUTRES = "AUTRES"
}

export enum ContratStatus {
  SIGNER = "SIGNER",
  PERDU = "PERDU",
  RESILIER = "RESILIER",
  EN_COURS = "EN_COURS"
}

export enum PeriodiciteStatus {
  MENSUELLE = "MENSUELLE",
  BIANNUELLE = "BIANNUELLE",
  BIMENSUELLE = "BIMENSUELLE",
  HEBDOMADAIRE = "HEBDOMADAIRE",
  TRIMESTRIELLE = "TRIMESTRIELLE"
}

export enum ProductStatus {
  NOUVEAU = "NOUVEAU",
  OCCASION = "OCCASION",
  EXPLOITATION = "EXPLOITATION",
  LIVRE = "LIVRE",
  VENDU = "VENDU"
}

export enum ProductType {
  LAVE_LINGE = "LAVE_LINGE",
  SECHE_LINGE = "SECHE_LINGE",
  STACKED_LAVE_LINGE = "STACKED_LAVE_LINGE",
  STACKED_SECHE_LINGE = "STACKED_SECHE_LINGE",
  CONDENSATEUR = "CONDENSATEUR",
  ARMOIRE_A_LESSIVE = "ARMOIRE_A_LESSIVE",
  PAYMENT_TERMINAL = "PAYMENT_TERMINAL",
  BALON_EAU_CHAUDE = "BALON_EAU_CHAUDE",
  POMPE_A_LESSIVE = "POMPE_A_LESSIVE",
  LINT_TRAP = "LINT_TRAP",
  MONNAYEUR = "MONNAYEUR",
  STAKED = "STAKED",
  ANTON = "ANTON",
  AIR_WALLET = "AIR_WALLET",
  NAYAX = "NAYAX",
  WI_WASH = "WI_WASH",
  WIMINI = "WIMINI",
  BIDON_LESSIVE = "BIDON_LESSIVE"
}

export enum ProductMake {
  SPEED_QUEEN = "SPEED_QUEEN",
  IPSO = "IPSO",
  MAYTAG = "MAYTAG",
  LG = "LG",
  LM_CONTROL = "LM_CONTROL",
  AIRWALLET = "AIRWALLET",
  IMSA = "IMSA",
  PRIMUS = "PRIMUS",
  MONEO = "MONEO",
  ELECTROCABLAGE = "ELECTROCABLAGE"
}

export enum ReservationStatus {
  AVAILABLE = "AVAILABLE",
  RESERVED = "RESERVED",
  DETRUIT = "DETRUIT"
}

export enum TypeContrat {
  AOT = "AOT",
  VENTE = "VENTE",
  FLUIDE = "FLUIDE",
  RELEVE = "RELEVE",
  LOCATION = "LOCATION",
  EXPLOITATION = "EXPLOITATION"
}

export enum TaskType {
  PANNE = "PANNE",
  CAISSE_ET_MAINTENANCE = "CAISSE_ET_MAINTENANCE",
  RELEVE_FACTURATION = "RELEVE_FACTURATION",
  ENLEVEMENT = "ENLEVEMENT",
  LOCATION_MAINTENANCE = "LOCATION_MAINTENANCE",
  INSTALLATION = "INSTALLATION",
  PREPARATION = "PREPARATION"
}

export enum TaskStatus {
  A_FAIRE = "A_FAIRE",
  ASSIGNE = "ASSIGNE",
  EN_COURS = "EN_COURS",
  FAITE = "FAITE",
  NON_FAITE = "NON_FAITE",
  A_REPROGRAMMER = "A_REPROGRAMMER",
  APPROUVE = "APPROUVE"
}

export enum TaskListStatus {
  A_FAIRE = "A_FAIRE",
  ASSIGNE = "ASSIGNE",
  EN_COURS = "EN_COURS",
  FAITE = "FAITE",
  APPROUVE = "APPROUVE"
}

export enum MoyenDePaiement {
  CB = "CB",
  JETONS = "JETONS",
  MONNAIE = "MONNAIE",
  CB_MONNAIE = "CB_MONNAIE",
  MONNAIE_JETONS = "MONNAIE_JETONS",
  CB_IZLY = "CB_IZLY",
  GRATUIT = "GRATUIT",
  CB_MONNAIE_JETONS = "CB_MONNAIE_JETONS",
  CB_JETONS = "CB_JETONS"
}

export enum NotificationType {
  LAVERIE_ALERT = "LAVERIE_ALERT",
  PRODUCT_ALERT = "PRODUCT_ALERT",
  SPAREPART_ALERT = "SPAREPART_ALERT"
}

export enum SparepartStatus {
  NOUVEAU = "NOUVEAU",
  OCCASION = "OCCASION"
}

export enum AccountOrigin {
  EXTENSION_CLIENT = "EXTENSION_CLIENT",
  BOUCHE_A_OREILLE = "BOUCHE_A_OREILLE",
  SITE_INTERNET = "SITE_INTERNET",
  PROSPECTION = "PROSPECTION",
  APPEL_DOFFRE = "APPEL_DOFFRE",
  AUTRES = "AUTRES"
}

export enum PriseDeContactType {
  Mail = "Mail",
  Telephone = "Telephone",
  RDV = "RDV"
}

export enum JetonLLType {
  MS10 = "MS10",
  MS11 = "MS11"
}

export enum JetonSLType {
  MS35 = "MS35",
  MS55 = "MS55"
}

export enum Priority {
  URGENT = "URGENT",
  NORMAL = "NORMAL"
}

export enum VaultFileType {
  SIGNATURE = "SIGNATURE",
  PHOTO = "PHOTO",
  PDF = "PDF",
  REPORT = "REPORT",
  ATTACHMENT = "ATTACHMENT"
}

export enum RefEntityType {
  TASK = "TASK",
  PANNE = "PANNE",
  PRODUCT = "PRODUCT",
  LAVERIE = "LAVERIE",
  SUPPORT_TICKET = "SUPPORT_TICKET"
}

export enum VaultFileTag {
  BEFORE = "BEFORE",
  AFTER = "AFTER"
}

export enum InterventionItemType {
  CHECKBOX = "CHECKBOX",
  TEXT = "TEXT",
  NUMERIC = "NUMERIC"
}

export enum SupportTicketStatus {
  OPEN = "OPEN",
  ASSIGNED = "ASSIGNED",
  IN_PROGRESS = "IN_PROGRESS",
  REJECTED = "REJECTED",
  DONE = "DONE"
}

export enum SupportTicketCallerType {
  MANAGER = "MANAGER",
  USER = "USER",
  PROSPECT = "PROSPECT",
  TECHNICIAN = "TECHNICIAN"
}

export enum SupportTicketContactType {
  EMAIL = "EMAIL",
  TELEPHONE = "TELEPHONE",
  MOBILE_APP = "MOBILE_APP",
  TOURNEE = "TOURNEE"
}

export enum SupportTicketConcernedService {
  COMMERCIAL = "COMMERCIAL",
  ACCOUNTING = "ACCOUNTING",
  TECHNICAL = "TECHNICAL",
  ADMINISTRATION = "ADMINISTRATION"
}

export enum SupportTicketWaterStatus {
  CLEAN_WATER = "CLEAN_WATER",
  DIRTY_WATER = "DIRTY_WATER"
}

export enum SupportTicketTapsStatus {
  OPEN_TAPS = "OPEN_TAPS",
  CLOSED_TAPS = "CLOSED_TAPS"
}

export enum SupportTicketType {
  TECHNICAL_ISSUE = "TECHNICAL_ISSUE",
  REIMBURSEMENT_REQUEST = "REIMBURSEMENT_REQUEST",
  GENERAL_INQUIRY = "GENERAL_INQUIRY",
}

export enum SupportTicketPaymentMethod {
  CARD = "CARD",
  CASH = "CASH",
  APPLE_PAY = "APPLE_PAY",
  AIR_WALLET = "AIR_WALLET"
}

export enum MobileDevice {
  AquaTab001 = "AquaTab001",
  AquaTab002 = "AquaTab002",
  AquaTab003 = "AquaTab003",
  AquaTab004 = "AquaTab004",
  AquaTab005 = "AquaTab005",
  AquaTab006 = "AquaTab006",
  AquaTab007 = "AquaTab007",
  AquaTab008 = "AquaTab008",
  AquaTab009 = "AquaTab009",
  AquaTab010 = "AquaTab010"
}